import { TuiAppBar } from '@taiga-ui/layout';
import { TuiPlatform } from '@taiga-ui/cdk';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TuiTitle, TuiIcon, TuiButton } from '@taiga-ui/core';
import { InputPhotosService } from '@core/services/workflow/input-photos.service';

@Component({
  selector: 'x-workflow-header',
  imports: [RouterLink, TuiAppBar, TuiButton, TuiPlatform, TuiIcon, TuiTitle],
  templateUrl: './workflow-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowHeaderComponent {
  public readonly $isWelcomeStep = input.required<boolean>({
    alias: 'isWelcomeStep',
  });
  public readonly $isRootPage = input<boolean>(false, {
    alias: 'isRootPage',
  });
  public readonly $currentWorkflowTitle = input<string>('', {
    alias: 'currentWorkflowTitle',
  });
  public readonly $currentWorkflowSubTitle = input<string>('', {
    alias: 'currentWorkflowSubTitle',
  });
  public readonly $returnLink = input<string>('', {
    alias: 'returnLink',
  });
  public readonly $baseRoute = input<string>('', {
    alias: 'baseRoute',
  });

  private readonly inputPhotosService = inject(InputPhotosService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  protected backClick() {
    const isPreviewOpen = this.inputPhotosService.photoPreviewKey() !== null;

    if (isPreviewOpen) {
      this.inputPhotosService.photoPreviewKey.set(null);
    } else {
      this.router.navigate([this.$returnLink()], {
        relativeTo: this.route,
        replaceUrl: true,
      });
    }
  }
}
